// extracted by mini-css-extract-plugin
module.exports = {"header":"FrontHeader_header__WzCbd","title":"FrontHeader_title__8_PMR","iconWrapper":"FrontHeader_iconWrapper__OyP1v"};